import basePath from "base_path";
import ActionTypes, {WorkflowsActionTypes} from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {WorkflowTask} from "common/flowmaster/types/task_config";
import {WorkflowId} from "common/flowmaster/types/workflow";

export type WorkflowTaskAddAction = {
  type: WorkflowsActionTypes["WORKFLOW_TASK_ADD"]["SUCCESS"];
  payload: {workflow_id: WorkflowId; tasks: WorkflowTask[]};
};

export default function addWorkflowTask(requestor) {
  return createReduxPromiseAction(
    ActionTypes.WORKFLOW_TASK_ADD,
    (organisationId: OrganisationId, workflowId: WorkflowId, name: string) => {
      return requestor
        .post(
          `${basePath}/organisation/${organisationId}/workflow/${workflowId}/task`,
          {name},
          {
            withCredentials: true,
          },
        )
        .then(response => {
          return response.data;
        });
    },
  );
}
